/* Hero studio panel.
 *
 * The zone rectangles below are the studio's own output for a tee front
 * (garmentPrintLayout in piobox-customizer/core/placements.js), so what a visitor
 * sees here is the same geometry the real customizer enforces. If those change,
 * change them here too — they are duplicated on purpose to keep the landing page
 * free of a runtime dependency on the studio bundle.
 */
(() => {
  const root = document.querySelector("[data-bdh]");
  if (!root) return;
  const $ = (s) => root.querySelector(s);

  const SPOTS = {
    "left-chest":   { cx: .6047, cy: .3237, w: .1176 },
    "center-chest": { cx: .4963, cy: .3944, w: .2912 },
    "full-front":   { cx: .4963, cy: .4596, w: .4253 },
  };
  const SPOT_ORDER = ["center-chest", "full-front", "left-chest"];
  const STAGE_CM = 55.9;      // the full stage width represents ~55.9cm of garment (was 22in)
  const ART_ASPECT = 0.33;    // height / width of the demo wordmark
  const AUTOPLAY_MS = 2400;   // dwell time on each placement before advancing
  const REDUCED_MOTION = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const base = root.dataset.photoBase;
  const COLOURWAY = {
    dark:  { src: base + root.dataset.photoDark,  alt: root.dataset.altDark,  onDark: true },
    light: { src: base + root.dataset.photoLight, alt: root.dataset.altLight, onDark: false },
  };

  const garment = $("[data-bdh-garment]"), zone = $("[data-bdh-zone]"), art = $("[data-bdh-art]"), stage = $(".bdh__stage");
  let colour = "dark", spot = "center-chest";

  // Drawn rather than fetched, so the hero never waits on a file.
  const mark = (light) => `<svg viewBox="0 0 300 100" xmlns="http://www.w3.org/2000/svg"><g fill="${light ? "#ffffff" : "#17170f"}">
    <text x="150" y="58" text-anchor="middle" font-family="Archivo,Helvetica,Arial,sans-serif" font-weight="900" font-size="52" letter-spacing="-2">BLANKD</text>
    <rect x="60" y="72" width="180" height="4"/>
    <text x="150" y="94" text-anchor="middle" font-family="JetBrains Mono,monospace" font-size="13" letter-spacing="6">EST. CAPE TOWN</text></g></svg>`;

  function render(animate = true) {
    const c = COLOURWAY[colour], s = SPOTS[spot];
    if (garment.dataset.src !== c.src) {
      garment.classList.add("is-out");
      setTimeout(() => {
        garment.src = c.src; garment.alt = c.alt || ""; garment.dataset.src = c.src;
        garment.classList.remove("is-out");
      }, animate ? 160 : 0);
    }
    zone.classList.toggle("on-dark", c.onDark);

    const zw = s.w, zh = s.w * 0.78;
    Object.assign(zone.style, {
      left: `${(s.cx - zw / 2) * 100}%`, top: `${(s.cy - zh / 2) * 100}%`,
      width: `${zw * 100}%`, height: `${zh * 100}%`,
    });
    const label = root.querySelector(`[data-spot="${spot}"]`).textContent.trim();
    $("[data-bdh-dim]").textContent = `${label.toUpperCase()} · ${(s.w * STAGE_CM).toFixed(1)} CM`;

    const aw = zw * 0.88, ah = aw * ART_ASPECT;
    Object.assign(art.style, { left: `${(s.cx - aw / 2) * 100}%`, top: `${(s.cy - ah / 2) * 100}%`, width: `${aw * 100}%` });
    art.innerHTML = mark(c.onDark);
    $("[data-bdh-size]").textContent = `${(aw * STAGE_CM).toFixed(1)} × ${(ah * STAGE_CM).toFixed(1)} cm`;
  }

  function setPressed(sel, matchValue, dataset) {
    root.querySelectorAll(sel).forEach((x) => x.setAttribute("aria-pressed", String(x.dataset[dataset] === matchValue)));
  }

  const press = (sel, set) => root.querySelectorAll(sel).forEach((b) => b.addEventListener("click", () => {
    stopAutoplay();
    set(b);
    root.querySelectorAll(sel).forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
    render();
  }));
  press("[data-col]", (b) => (colour = b.dataset.col));
  press("[data-spot]", (b) => (spot = b.dataset.spot));

  render(false);

  // --- Autoplay: step through the placements on its own, so the first thing a
  // visitor sees is the studio doing its job without having to touch anything.
  // Stops for good the moment a visitor takes the controls themselves.
  let autoplayTimer = null, autoplayIndex = 0, autoplayStopped = false;

  function stopAutoplay() {
    autoplayStopped = true;
    if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; }
    root.classList.remove("is-autoplaying");
  }

  function scheduleNext() {
    if (autoplayStopped) return;
    autoplayTimer = setTimeout(step, AUTOPLAY_MS);
  }

  function step() {
    if (autoplayStopped) return;
    autoplayIndex = (autoplayIndex + 1) % SPOT_ORDER.length;
    spot = SPOT_ORDER[autoplayIndex];
    setPressed("[data-spot]", spot, "spot");
    render();
    scheduleNext();
  }

  function startAutoplay() {
    if (REDUCED_MOTION || autoplayStopped) return;
    root.classList.add("is-autoplaying");
    scheduleNext();
  }

  // A visitor mousing over or focusing the panel is a person about to read the
  // numbers — freeze on whatever is showing rather than swapping it under them.
  if (stage) {
    root.addEventListener("mouseenter", () => { if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; } }, true);
    root.addEventListener("mouseleave", () => { if (!autoplayStopped && !autoplayTimer) scheduleNext(); }, true);
    root.addEventListener("focusin", () => { if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; } });
    root.addEventListener("focusout", () => { if (!autoplayStopped && !autoplayTimer && !root.contains(document.activeElement)) scheduleNext(); });
  }

  // Opening move: the mark drops into the print area once, then — once that
  // settles — the placements begin cycling on their own.
  if (!REDUCED_MOTION) {
    art.style.opacity = "0";
    art.style.transform = "translateY(-12px)";
    setTimeout(() => {
      art.style.transition = "opacity .7s cubic-bezier(.16,1,.3,1), transform .7s cubic-bezier(.16,1,.3,1)";
      art.style.opacity = "1"; art.style.transform = "none";
    }, 560);
    setTimeout(startAutoplay, 560 + 700 + 300);
  }
})();
